export default __webpack_public_path__ + "static/media/banner.5b5ebd6b.svg";